import { IconButton } from '@mui/material';

const LANGS = [
  {
    value: 'en',
    icon: '/assets/layer_2.webp',
  },
];

export default function LanguagePopover() {
  return (
    <IconButton
      disabled
      sx={{
        padding: 0,
        width: 160,
        height: 120,
      }}
    >
      <img src={LANGS[0].icon} alt="Language selector" width="160" height="120" />
    </IconButton>
  );
}
